<template>
<div class="unauthorized">
  {{$t(error)}}
  <div class="get-back">
    <router-link to="/">
      {{$t('ui.global.back_to_home')}}
    </router-link>
  </div>
</div>
</template>
<script>
export default {
  computed: {
    error(){
      let error = this.$store.state.error
      if(error){
        return error.message
      }else{
        return ""
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Unauthorized.vue?2907fd3b